"use client";

import * as React from "react";
import { cn } from "@/lib/utils";

export interface ProgressRingProps {
  value: number;
  size?: number;
  strokeWidth?: number;
  showValue?: boolean;
  /** CSS color for the progress arc (e.g. from percentColor). */
  strokeColor?: string;
  className?: string;
}

export function ProgressRing({
  value,
  size = 56,
  strokeWidth = 6,
  showValue = false,
  strokeColor,
  className,
}: ProgressRingProps) {
  const normalized = Math.max(0, Math.min(100, value));
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (normalized / 100) * circumference;

  return (
    <div
      className={cn("relative inline-flex items-center justify-center", className)}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          className="fill-transparent stroke-slate-200 dark:stroke-zinc-700"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          className={strokeColor ? "fill-transparent transition-all duration-500" : "fill-transparent stroke-violet-600 transition-all duration-500 dark:stroke-violet-400"}
          style={strokeColor ? { stroke: strokeColor } : undefined}
        />
      </svg>
      {showValue && (
        <span className="absolute inset-0 flex items-center justify-center text-xs font-semibold text-slate-700 dark:text-zinc-200">
          {Math.round(normalized)}%
        </span>
      )}
    </div>
  );
}
